import outlookIcon from '@/assets/outlook.webp?url';
import teamsIcon from '@/assets/teams.webp?url';
import {
    ConsentStatus,
    MicrosoftCapability
} from '@/services/microsoftCapabilities';

export type CapabilityInfos = {
    name: string;
    /** One line, truncated in the row: the scope chip beside it carries the exact grant. */
    description: string;
    icon: string;
};

export const CapabilityConfig: Record<MicrosoftCapability, CapabilityInfos> = {
    [MicrosoftCapability.OUTLOOK_MAIL]: {
        name: 'Outlook mail',
        description:
            "Search, read and draft emails in the member's own mailbox",
        icon: outlookIcon
    },
    [MicrosoftCapability.TEAMS_MESSAGES]: {
        name: 'Teams messages',
        description:
            "Search and read the member's own Teams chats, channels and shared files",
        icon: teamsIcon
    },
    [MicrosoftCapability.TEAMS_MEETINGS]: {
        name: 'Teams meetings',
        description:
            'Read the transcripts of Teams meetings the member was invited to',
        icon: teamsIcon
    }
};

type ManualStep = { text: string; linkLabel: string; url: string };

/**
 * What a capability needs beyond the grant, in a console Elqano cannot reach.
 *
 * Shown whatever the consent status: the Teams setting is off in every tenant by default, so an
 * admin about to grant has to see the whole job, not discover the second half afterwards.
 */
export const CAPABILITY_MANUAL_STEPS: Partial<
    Record<MicrosoftCapability, ManualStep>
> = {
    [MicrosoftCapability.TEAMS_MEETINGS]: {
        text: 'Transcript API access must also be turned on in the Teams admin center. It is off by default, and this grant alone does not reach transcripts.',
        linkLabel: 'How to turn it on',
        url: 'https://docs.elqano.com/playground/teams-meetings'
    }
};

export const CAPABILITY_STATE_LABELS: Record<ConsentStatus, string> = {
    [ConsentStatus.NOT_GRANTED]: 'Not granted',
    [ConsentStatus.INCOMPLETE]: 'Update available',
    [ConsentStatus.GRANTED]: 'Granted'
};

// The dot carries the state; the words stay neutral.
export const CAPABILITY_DOT_CLASSES: Record<ConsentStatus, string> = {
    [ConsentStatus.NOT_GRANTED]: 'bg-muted-foreground/40',
    [ConsentStatus.INCOMPLETE]: 'bg-orangeContrast25',
    [ConsentStatus.GRANTED]: 'bg-green100'
};

// Both open Microsoft's consent screen, so they name the effect. The Entra button only opens
// the portal, so it names the destination instead.
export const GRANT_LABEL = 'Grant access';
export const UPDATE_LABEL = 'Update access';
